<template>
  <div>
    <h1>Diffie Hellman</h1>
    <p>
      Stell dir vor, du möchtest mit deinem Freund Charlie verschlüsselte
      Nachrichten austauschen. Dazu braucht ihr einen gemeinsamen Schlüssel,
      den sowohl Du als auch Charlie hat. Du hast jedoch keine Möglichkeit
      dich mit Charlie zu treffen, um einen gemeinsamen Schlüssel vorab zu
      vereinbaren, da Mallory dich auf Schritt und tritt verfolgt und alles
      abhört, was du mit Charlie besprichst. Dementsprechend würde Mallory
      auch den Schlüssel lernen. Kannst du trotzdem mit Charlie einen
      Schlüssel vereinbaren, den Mallory nicht kennen wird? Klar, mit dem
      Verfahren von Whit Diffie und Martin Hellman!
    </p>
    <h2>Anschauliches Diffie-Hellman mit Farben (additiv)</h2>
    <p>
      Du kannst die zu wählenden Farben einfach mit einem Klick auf den zu
      Anfang schwarzen Kreis ändern und sehen, wie sich die anderen Farben
      verändern. Wähle bevorzugt eher dunkle Farben, dann sieht man die
      Zwischenschritte und das Ergebnis besser.
    </p>
    <div class="columns">
      <div class="column is-one-third">
        <p class="step">1. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Einigung auf Erzeugerfarbe
            </p>
          </header>
          <div class="card-content">
            <p>
              Alice und Bob einigen sich auf eine Erzeugerfarbe.
              Diese ist nicht geheim.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <verte picker="square" model="rgb" :recentColors="null"
                       :enableAlpha="false" v-model="generatorColor"></verte>
              </div>
              <div class="column">Erzeugerfarbe</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third"></div>
    </div>

    <div class="columns">
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Schlüsselerzeugung Alice</p>
          </header>
          <div class="card-content">
            <p>Alice wählt ihre geheime Farbe.</p>
            <div class="columns">
              <div class="column is-narrow">
                <verte picker="square" model="rgb" :recentColors="null"
                       :enableAlpha="false" v-model="alicePrivateColor"></verte>
              </div>
              <div class="column">
                Alices geheime Farbe
              </div>
            </div>
            <p>
              Sie mischt ihre geheime Farbe mit der Erzeugerfarbe und erhält
              ihre öffentliche Farbe.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="alicePublicColor"></circle>
                </svg>
              </div>
              <div class="column">
                Alices öffentliche Farbe
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
        <p class="step">2. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Schlüsselerzeugung Bob</p>
          </header>
          <div class="card-content">
            <p>Bob wählt seine geheime Farbe.</p>
            <div class="columns">
              <div class="column is-narrow">
                <verte picker="square" model="rgb" :recentColors="null"
                       :enableAlpha="false" v-model="bobPrivateColor"></verte>
              </div>
              <div class="column">
                Bobs geheime Farbe
              </div>
            </div>
            <p>
              Er mischt seine geheime Farbe mit der Erzeugerfarbe und erhält
              seine öffentliche Farbe.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="bobPublicColor"></circle>
                </svg>
              </div>
              <div class="column">
                Bobs öffentliche Farbe
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <p class="step">3. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Austausch der öffentlichen Farben
            </p>
          </header>
          <div class="card-content">
            <p>Alice schickt ihre öffentliche Farbe an Bob</p>
            <p>Bob schickt seine öffentliche Farbe an Alice</p>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
      </div>
    </div>


    <div class="columns">
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Geheimniserzeugung Alice</p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="alicePrivateColor"></circle>
                </svg>
              </div>
              <div class="column">
                Alices geheime Farbe
              </div>
            </div>
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="bobPublicColor"></circle>
                </svg>
              </div>
              <div class="column">
                Bobs öffentliche Farbe
              </div>
            </div>
            <p>
              Alice mischt ihre geheime Farbe mit Bobs öffentlicher Farbe
              und erhält die gemeinsame geheime Farbe.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="aliceSharedColor"></circle>
                </svg>
              </div>
              <div class="column">
                Gemeinsame geheime Farbe
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
        <p class="step">4. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Geheimniserzeugung Bob</p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="bobPrivateColor"></circle>
                </svg>
              </div>
              <div class="column">
                Bobs geheime Farbe
              </div>
            </div>
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="alicePublicColor"></circle>
                </svg>
              </div>
              <div class="column">
                Alices öffentliche Farbe
              </div>
            </div>
            <p>
              Bob mischt seine geheime Farbe mit Alices öffentlicher Farbe
              und erhält die gemeinsame geheime Farbe.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <svg class="chosen-color" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="12" :fill="bobSharedColor"></circle>
                </svg>
              </div>
              <div class="column">
                Gemeinsame geheime Farbe
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <p class="step">Ergebnis</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Gemeinsame geheime Farbe</p>
          </header>
          <div class="card-content">
            <p>
              Sowohl Alice als auch Bob haben die gleiche Farbe erzeugt.
              Diese kann als Grundlage für einen symmetrischen Schlüssel dienen
              mit denen beide dann verschlüsselt kommunizieren können.
            </p>
            <p>
              Ein Angreifer, der die ausgetauschten öffentlichen Farben gesehen
              hat, kann jedoch nicht die gemeinsame Farbe erzeugen, da ihm dazu
              die geheimen Farben von Alice und Bob fehlen.
            </p>
          </div>
        </div>
      </div>
      <div class="column is-one-third"></div>
    </div>


    <h2>Diffie-Hellman mit Zahlen (Restklassengruppe)</h2>
    <p>
      Da Computer in der Regel nicht so gut mit Farben rechnen können, wird
      in der Praxis Diffie-Hellman mit Zahlen gerechnet. Dabei steckt relativ
      viel mathematische Theorie dahinter, warum das funktioniert. Wir
      beschreiben hier nur die Schritte, ohne genauer auf Algebra und
      Zahlentheorie einzugehen. Moderne Verfahren rechnen bei Diffie-Hellman
      sogar mit Punkten (also zwei Zahlen: eine x- und eine y-Koordinate), die
      auf speziellen Kurven, sogenannten elliptischen Kurven, liegen. Das
      Verfahren mit elliptischen Kurven ist dabei deutlich effizienter und
      sicherer. Wir bleiben aber hier beim einfachen Verfahren, das nur
      natürliche Zahlen modulo einer Primzahl verwendet.
    </p>

    <div class="columns">
      <div class="column is-one-third">
        <p class="step">1. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Einigung auf Erzeuger (Primzahl+Erzeugerelement)
            </p>
          </header>
          <div class="card-content">
            <p>
              Alice und Bob einigen sich auf eine Primzahl <em>p</em>
              und einen Erzeugerelement <em>g</em>, so dass
              <em>g</em><sup>1</sup>, <em>g</em><sup>2</sup>, ...,
              <em>g</em><sup>p - 1</sup> alle Zahlen zwischen 1 (inklusive) und
              <em>p</em> (exklusive) erzeugt. Beide Werte sind nicht geheim.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <em>p</em> = 7
              </div>
              <div class="column">Primzahl</div>
            </div>
            <div class="columns">
              <div class="column is-narrow">
                <em>g</em> = 3
              </div>
              <div class="column">Erzeugerelement</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third"></div>
    </div>

    <div class="columns">
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Schlüsselerzeugung Alice</p>
          </header>
          <div class="card-content">
            <p>Alice wählt ihren geheimen Schlüssel zwischen 2 und <em>p</em> - 1</p>
            <div class="columns">
              <div class="column is-narrow">
                <em>a</em> = 4
              </div>
              <div class="column">
                Alices geheimer Schlüssel
              </div>
            </div>
            <p>
              Sie berechnet <em>A</em> = <em>g</em><sup><em>a</em></sup>&nbsp;&nbsp;(mod <em>p</em>)
              und erhält ihren öffentlichen Schlüssel.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <em>A</em>
              </div>
              <div class="column">
                Alices öffentlicher Schlüssel
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
        <p class="step">2. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Schlüsselerzeugung Bob</p>
          </header>
          <div class="card-content">
            <p>Bob wählt seinen geheimen Schlüssel zwischen 2 und <em>p</em> - 1</p>
            <div class="columns">
              <div class="column is-narrow">
                <em>b</em> = 2
              </div>
              <div class="column">
                Bobs geheimer Schlüssel
              </div>
            </div>
            <p>
              Er berechnet <em>B</em> = <em>g</em><sup><em>b</em></sup>&nbsp;&nbsp;(mod <em>p</em>)
              und erhält seinen öffentlichen Schlüssel.
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <em>B</em>
              </div>
              <div class="column">
                Bobs öffentlicher Schlüssel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <p class="step">3. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Austausch der öffentlichen Schlüssel
            </p>
          </header>
          <div class="card-content">
            <p>Alice schickt ihren öffentlichen Schlüssel an Bob</p>
            <p>Bob schickt seinen öffentlichen Schlüssel an Alice</p>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
      </div>
    </div>


    <div class="columns">
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Geheimniserzeugung Alice</p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-narrow">
                <em>a</em>
              </div>
              <div class="column">
                Alices geheimer Schlüssel
              </div>
            </div>
            <div class="columns">
              <div class="column is-narrow">
                <em>B</em>
              </div>
              <div class="column">
                Bobs öffentlicher Schlüssel
              </div>
            </div>
            <p>
              Alice potenziert Bobs öffentlichen Schlüssel mit ihrem geheimen
              Schlüssel und erhält das gemeinsame Geheimnis:
              <em>s</em> = <em>B</em><sup><em>a</em></sup>&nbsp;&nbsp;(mod <em>p</em>)
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <em>s</em>
              </div>
              <div class="column">
                Gemeinsames Geheimnis
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
        <p class="step">4. Schritt</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Geheimniserzeugung Bob</p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-narrow">
                <em>b</em>
              </div>
              <div class="column">
                Bobs geheimer Schlüssel
              </div>
            </div>
            <div class="columns">
              <div class="column is-narrow">
                <em>A</em>
              </div>
              <div class="column">
                Alices öffentlicher Schlüssel
              </div>
            </div>
            <p>
              Bob potenziert Alices öffentlichen Schlüssel mit seinem geheimen
              Schlüssel und erhält das gemeinsame Geheimnis:
              <em>s</em> = <em>A</em><sup><em>b</em></sup>&nbsp;&nbsp;(mod <em>p</em>)
            </p>
            <div class="columns">
              <div class="column is-narrow">
                <em>s</em>
              </div>
              <div class="column">
                Gemeinsames Geheimnis
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <p class="step">Ergebnis</p>
      </div>
      <div class="column is-one-third">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Gemeinsames Geheimnis</p>
          </header>
          <div class="card-content">
            <p>
              Sowohl Alice als auch Bob haben das gleiche Geheimnis erzeugt,
              nämlich eine Zahl zwischen 1 und <em>p</em> - 1.
              Diese kann als Grundlage für einen symmetrischen Schlüssel dienen
              mit denen beide dann verschlüsselt kommunizieren können.
            </p>
            <p>
              Ein Angreifer, der die ausgetauschten öffentlichen Schlüssel
              gesehen hat, kann jedoch nicht das gemeinsame Geheimnis erzeugen,
              da ihm dazu die geheimen Schlüssel von Alice und Bob fehlen.
            </p>
            <p>
              Warum kommt für Alice und Bob das gleiche Geheimnis raus?
              Ganz einfach:<br/>
              <em>s</em> =
              <em>B</em><sup><em>a</em></sup> =
              (<em>g</em><sup>b</sup>)<sup><em>a</em></sup> =
              <em>g</em><sup>ba</sup> =
              <em>g</em><sup>ab</sup> =
              (<em>g</em><sup>a</sup>)<sup><em>b</em></sup> =
              <em>A</em><sup><em>b</em></sup> =
              <em>s</em>
              &nbsp;&nbsp;(mod <em>p</em>)

            </p>
          </div>
        </div>
      </div>
      <div class="column is-one-third"></div>
    </div>
  </div>
</template>
<style>
  .verte {
    justify-content:left;
  }
  .chosen-color {
    width:24px;
    height:24px;
  }

  .step {
    font-size:3em;
    color:#ccc;
    font-style:italic;
  }
</style>

<script>
  import Verte from 'verte'
  import 'verte/dist/verte.css'

  export default {
    data() {
      return {
        alicePrivateColor: 'rgb(0,0,0)',
        bobPrivateColor: 'rgb(0,0,0)',
        generatorColor: 'rgb(0,0,0)'
      }
    },
    computed: {
      alicePublicColor() {
        return mixColor(this.alicePrivateColor, this.generatorColor)
      },
      bobPublicColor() {
        return mixColor(this.bobPrivateColor, this.generatorColor)
      },
      aliceSharedColor() {
        return mixColor(this.alicePrivateColor, this.bobPublicColor)
      },
      bobSharedColor() {
        return mixColor(this.bobPrivateColor, this.alicePublicColor)
      }
    },
    components: { Verte }
  }

  function mixColor(colorA, colorB) {

    let c1 = parseColor(colorA)
    let c2 = parseColor(colorB)
    let r = Math.min(c1.r + c2.r, 255)
    let g = Math.min(c1.g + c2.g, 255)
    let b = Math.min(c1.b + c2.b, 255)
    return 'rgb(' + r + ',' + g + ',' + b + ')'
  }

  function parseColor(c) {
    let tmp = c.match(/rgb\(([\d.]+),([\d.]+),([\d.]+)\)/)
    return {
      r: parseInt(tmp[1], 10),
      g: parseInt(tmp[2], 10),
      b: parseInt(tmp[3], 10)
    }
  }
</script>